<div class="container-fluid">
  <div class="flex justify-between items-center flex-nowrap gap-2">
    <nz-page-header-extra>
      <nz-space>
        <button nz-button
          class="mr-3 rounded-md shadow-sm hover:shadow-md transition-all duration-300 flex items-center"
          [nzType]="'primary'" nzSize="large" (click)="missingReportsForm()">
          <i nz-icon nzType="file-search" nzTheme="outline" class="mr-2"></i>
          <span>Missing Reports</span>
        </button>
        <button nz-button
          class="mr-3 rounded-md shadow-sm hover:shadow-md transition-all duration-300 flex items-center"
          [nzType]="'primary'" [class.ant-btn-white]="activeForm === 'patching'" nzSize="large" (click)="toggleForm('patching')">
          <i nz-icon nzType="tool" nzTheme="outline" class="mr-2"></i>
          <span>Data Patching</span>
        </button>
        <button nz-button
          class="mr-3 rounded-md shadow-sm hover:shadow-md transition-all duration-300 flex items-center"
          [nzType]="'primary'" [class.ant-btn-white]="activeForm === 'recall'" nzSize="large" (click)="toggleForm('recall')">
          <i nz-icon nzType="reload" nzTheme="outline" class="mr-2"></i>
          <span>Data Recall</span>
        </button>
      </nz-space>
    </nz-page-header-extra>
  </div>

  <!-- Patching Form -->
  <div class="mt-4" *ngIf="activeForm === 'patching'">
    <div class="bg-white p-6 rounded-lg shadow">
      <h2 class="text-xl mb-4">Data Patching</h2>
      <form [formGroup]="patchingForm" nz-form nzLayout="vertical">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <nz-form-item class="w-full">
            <nz-form-label class="text-left" nzRequired>Date Range</nz-form-label>
            <nz-form-control [nzErrorTip]="dateRangeError">
              <nz-date-picker class="w-full" formControlName="date_range" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss">
              </nz-date-picker>
            </nz-form-control>
            <ng-template #dateRangeError let-control>
              @if (control.errors?.['required']) { Date Range is Required! }
            </ng-template>
          </nz-form-item>

          <nz-form-item class="w-full">
            <nz-form-label nzRequired>Measurement</nz-form-label>
            <nz-form-control [nzErrorTip]="mesureError">
              <nz-select class="w-full" formControlName="measurement" nzPlaceHolder="Select Measurement">
                <nz-option nzValue="temperature" nzLabel="Temperature"></nz-option>
                <nz-option nzValue="humidity" nzLabel="Humidity"></nz-option>
                <nz-option nzValue="pressure" nzLabel="Pressure"></nz-option>
                <nz-option nzValue="battery" nzLabel="Battery"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #mesureError let-control>
              @if (control.errors?.['required']) { Measurement is Required! }
            </ng-template>
          </nz-form-item>

          <nz-form-item class="w-full">
            <nz-form-label nzRequired>Value</nz-form-label>
            <nz-form-control [nzErrorTip]="fieldError">
              <input nz-input class="w-full" formControlName="field" placeholder="Enter Value" maxlength="30">
            </nz-form-control>
            <ng-template #fieldError let-control>
              @if (control.errors?.['required']) { Field is Required! }
            </ng-template>
          </nz-form-item>

          <nz-form-item class="w-full">
            <nz-form-label nzFor="deviceeui" nzRequired>Device Eui</nz-form-label>
            <nz-form-control [nzErrorTip]="devEuiError">
              <nz-select class="w-full" formControlName="deviceeui" nzMode="multiple" nzPlaceHolder="Select Device Euis">
                <nz-option *ngFor="let device of devices" [nzValue]="device" [nzLabel]="device"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #devEuiError let-control>
              @if (control.errors?.['required']) { Device Eui is Required! }
            </ng-template>
          </nz-form-item>
        </div>

        <div class="flex justify-end mt-6">
          <button nz-button nzType="default" class="mr-2" (click)="closeForm()">Cancel</button>
          <button nz-button nzType="primary" (click)="onPatchingFormSubmit()" [nzLoading]="isConfirmLoading">Submit</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Recall Form -->
  <div class="mt-4" *ngIf="activeForm === 'recall'">
    <div class="bg-white p-6 rounded-lg shadow">
      <h2 class="text-xl mb-4">Data Recall</h2>
      <form [formGroup]="recallForm" nz-form nzLayout="vertical">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <nz-form-item class="w-full">
            <nz-form-label nzRequired>Device Eui</nz-form-label>
            <nz-form-control [nzErrorTip]="devEuiError">
              <input nz-input class="w-full" formControlName="deviceEui" maxlength="30" placeholder="Enter Device Eui" />
            </nz-form-control>
            <ng-template #devEuiError let-control>
              @if (control.errors?.['required']) { Device Eui is Required! }
            </ng-template>
          </nz-form-item>

          <nz-form-item class="w-full">
            <nz-form-label class="text-left" nzRequired>Date Range</nz-form-label>
            <nz-form-control [nzErrorTip]="dateRangeError">
              <nz-range-picker class="w-full" formControlName="date_range" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss">
              </nz-range-picker>
            </nz-form-control>
            <ng-template #dateRangeError let-control>
              @if (control.errors?.['required']) { Date Range is Required! }
            </ng-template>
          </nz-form-item>
        </div>

        <div class="flex justify-end mt-6">
          <button nz-button nzType="default" class="mr-2" (click)="closeForm()">Cancel</button>
          <button nz-button nzType="primary" (click)="onRecallFormSubmit()" [nzLoading]="isConfirmLoading">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
